import { useSettings } from "@/context/SettingsContext";

export function sanitizeWhatsAppNumber(number) {
    return String(number || "").replace(/\D+/g, "");
}

export function buildWhatsAppUrl(number, message) {
    const digits = sanitizeWhatsAppNumber(number);
    const text = encodeURIComponent(message || "");
    const numPart = digits ? digits : "";
    return `https://wa.me/${numPart}${text ? `?text=${text}` : ""}`;
}

export default function WhatsAppFAB() {
    const { settings } = useSettings();
    const raw = settings?.whatsapp_number || "";
    const digits = sanitizeWhatsAppNumber(raw);
    if (!digits) return null;

    const message = "Hi Opensea Fishing Tackles, I need help with a product.";
    const href = buildWhatsAppUrl(digits, message);

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            data-testid="whatsapp-fab"
            className="fixed right-4 bottom-28 md:right-6 md:bottom-6 z-30 inline-flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/40 ring-1 ring-black/30 hover:bg-[#1ebe5d] active:scale-95 transition-transform w-14 h-14"
        >
            {/* WhatsApp glyph (inline SVG to avoid new dep) */}
            <svg
                viewBox="0 0 32 32"
                width="28"
                height="28"
                fill="currentColor"
                aria-hidden="true"
                focusable="false"
            >
                <path d="M19.11 17.27c-.27-.14-1.59-.78-1.83-.87-.25-.09-.43-.13-.61.13-.18.27-.7.87-.86 1.05-.16.18-.31.2-.58.07-.27-.14-1.13-.42-2.16-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.31.4-.46.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.14-.61-1.46-.84-2-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.97 2.63 1.11 2.81.13.18 1.92 2.93 4.65 4.11.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.59-.65 1.81-1.27.22-.62.22-1.16.16-1.27-.06-.11-.25-.18-.52-.31zM16.05 4C9.39 4 4 9.39 4 16.04c0 2.36.69 4.55 1.88 6.4L4 28l5.69-1.84c1.78 1.05 3.85 1.66 6.36 1.66 6.66 0 12.05-5.39 12.05-12.04C28.1 9.39 22.71 4 16.05 4zm0 21.84c-2.07 0-3.99-.62-5.6-1.69l-.4-.25-3.37 1.09 1.09-3.28-.26-.42a9.83 9.83 0 0 1-1.5-5.25c0-5.43 4.42-9.85 9.84-9.85a9.84 9.84 0 0 1 9.85 9.85c0 5.43-4.42 9.8-9.65 9.8z" />
            </svg>
        </a>
    );
}
